import { createApp } from 'vue'
import Vue from 'vue';
import App from './App.vue';
import router from './router'

import '@arco-design/web-vue/dist/arco.css';
import ArcoVue from '@arco-design/web-vue';
import ArcoVueIcon from '@arco-design/web-vue/es/icon';

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './styles/index.css' 

// 一键置空所有log 正式外网
console.log = function () { } 

import moment from 'moment'

import * as echarts from 'echarts'

import CONST from './utils/const'
window.CONST = CONST

import dayjs from 'dayjs'

router.beforeEach((to, from, next) => {    
  // chrome
  document.body.scrollTop = 0
  // firefox
  document.documentElement.scrollTop = 0
  // safari
  window.pageYOffset = 0
  next()
})

const app = createApp(App)
.use(ArcoVue)
.use(router)
.use(ElementPlus)
.use(moment)
.use(dayjs)
.use(ArcoVueIcon);
app.mount('#app');